import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { styleListPart } from './style';
import { Col, Row, Container } from 'react-bootstrap';
import { Book } from 'react-bootstrap-icons';

const listPart = ({
    fungsinya, listNovelnya, bukudipilihnya
  }) => {
  return (
      <div className={styleListPart}>
        
        <Container fluid className="Header">
            <Row>
                <Col className="buatCover">
                    <img src={listNovelnya[bukudipilihnya-1].cover} alt="coverNovel" className="gambarCover"/>
                </Col>
                <Col className="buatKanan">
                    <Row className="rowKanan">
                <h1 className="judulnya">{listNovelnya[bukudipilihnya-1].judul}</h1>
                <div className="tombolBaca" onClick={()=>fungsinya(1)}>
                <Book className="logoBuku" color="white"/>
                        <h1 className="katakata">Mulai Membaca</h1>
                </div>
                </Row>
                </Col> 
            </Row>
        </Container>

        <div className="bawah">
            <Container fluid  className="buatPart">
                <h1 className="headerList">List Chapter :</h1>
                {listNovelnya[bukudipilihnya-1].listChapter.map((post) =>(
                                <Container fluid>
                                <div className="tulisanChapter" onClick={()=>fungsinya(post.id)}>
                                {post.judulChapter}
                            </div>
                            <div className="sekatChapter"/>
                            </Container>
                            )
                )}
                <div className="sekatBawah"/>
            </Container>
        </div>
        
    </div>
  );
};
export default listPart;
